export default (domElement) => {
    if (!domElement) return false;

    const computedStyle = window.getComputedStyle(domElement);

    if (!computedStyle) return false;

    return computedStyle.overflowY === 'scroll' || computedStyle.overflowY === 'auto';
};
